import { createAction } from '@reduxjs/toolkit';
import TYPES from '../../action-types';

const crawlingEvent = createAction(TYPES.ASSETS.CRAWLING_EVENT);

export default crawlingEvent;
